import { Stack } from '@mui/material';
import React from 'react';
import CalendarList from './CalendarList';

const Calendar = () => {
    return (
        <>
            <Stack sx={{ pt: '30px', gap: 4 }}>
                <CalendarList />
            </Stack>
        </>
    );
};

export default Calendar;
